<template>

  <section class="bio">
    <div class="bio__container">
      <h2 class="bio__container__title">Bio</h2>
      <div class="bio__container__text">
        I’m an Italian Visual and Product Designer with a Graphic Design background and <strong>9 years of experience</strong>.
        <br><br>
        Thanks to my recent experience in wefox, I manage to master my UX skills and to take care of the <strong>end to end design process from the discovery to Design QA</strong>.
        <br>I had the opportunity to learn and interact closely with developers, product managers and other stakeholders, sharing knowledge and skills.
        <br><br>
        From my past experiences in a digital agency I've also worked for clients in industries such as government, nonprofit, smart working, fashion, e-commerce.
      </div>
      <a href="https://drive.google.com/open?id=1Zjbxev_mBaSKtL85j8gJg_kiuHcl6mbb" target="_blank" class="bio__container__download button">
        <span>Download the resume</span>
      </a>
    </div>
  </section>

</template>

<script>

  export default {
    name: 'Bio'
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .bio {
    @include container;
    justify-content: flex-end;
    margin-bottom: 80px;
  }

  .bio__container {
    width: 50%;
    margin-right: 100px;

    @include mq(medium) {
      width: 100%;
      margin-right: 70px;
    }

    @include mq(small) {
      margin-right: 0;
    }
  }

  .bio__container__title {
    @include ui(back);
    margin-bottom: 20px;
  }
  .bio__container__text {
    @include current(big);
    margin-bottom: 40px;
  }

  .bio__container__download {
  }

</style>
